var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIndicatorRelevantItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "#364863"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78289 3L8.78289 7.52603C8.78289 7.9 8.76316 8.26781 8.72368 8.62945C8.68421 8.98699 8.63377 9.36712 8.57237 9.76986H7.46711C7.4057 9.36712 7.35526 8.98699 7.31579 8.62945C7.27632 8.26781 7.25658 7.9 7.25658 7.52603L7.25658 3H8.78289ZM7 12.0753C7 11.9479 7.02412 11.8267 7.07237 11.7116C7.125 11.5966 7.19518 11.4979 7.28289 11.4158C7.375 11.3336 7.48246 11.2678 7.60526 11.2185C7.72807 11.1692 7.85965 11.1445 8 11.1445C8.13596 11.1445 8.26535 11.1692 8.38816 11.2185C8.51096 11.2678 8.61623 11.3336 8.70395 11.4158C8.79605 11.4979 8.86842 11.5966 8.92105 11.7116C8.97368 11.8267 9 11.9479 9 12.0753C9 12.2069 8.97368 12.3301 8.92105 12.4452C8.86842 12.5562 8.79605 12.6527 8.70395 12.7349C8.61623 12.8171 8.51096 12.8808 8.38816 12.926C8.26535 12.9753 8.13596 13 8 13C7.85965 13 7.72807 12.9753 7.60526 12.926C7.48246 12.8808 7.375 12.8171 7.28289 12.7349C7.19518 12.6527 7.125 12.5562 7.07237 12.4452C7.02412 12.3301 7 12.2069 7 12.0753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndicatorRelevantItem);
export default __webpack_public_path__ + "static/media/icon-indicator-relevant-item.fbada5a40e3a1aeec82244ad1c6469fa.svg";
export { ForwardRef as ReactComponent };